export interface IImgParams {
    bottom?: string,
    left?: string,
    top?: string,
    right?: string,
    width?: string,
    height?: string,
    display?: string,
    filter?: string,
    'max-width'?: string,
}

interface IAnimatedImage {
    id: string,
    src: string,
    image: string,
    image_webp: string,
    left?: string,
    right?: string,
    params?: IImgParams,
    desktopParams?: IImgParams,
    laptopParams?: IImgParams,
    tabletParams?: IImgParams,
    mobileParams?: IImgParams,
}

export const imagesWithoutDomofon: IAnimatedImage[] = [
    {
        id: '1',
        image_webp: require('~/static/images/domofon/connect-domofon/animated-img/center.webp'),
        image: require('~/static/images/domofon/connect-domofon/animated-img/center.png'),
        src: 'center',
        params: {
            bottom: '15%',
            left: '50%',
        },
        laptopParams: {
            filter: 'blur(3px)',
            bottom: '10%',
        },
        mobileParams: {
            display: 'none',
        },
    },
    {
        id: '2',
        image_webp: require('~/static/images/domofon/connect-domofon/animated-img/left-top.webp'),
        image: require('~/static/images/domofon/connect-domofon/animated-img/left-top.png'),
        src: 'left-top',
        left: '-15%',
        params: {
            top: '2%',
            left: '5%',
            width: '110px',
            height: '110px',
        },
        mobileParams: {
            width: '100px',
            height: '100px',
            left: '-25px',
        },
    },
    {
        id: '3',
        image_webp: require('~/static/images/domofon/connect-domofon/animated-img/left-bottom.webp'),
        image: require('~/static/images/domofon/connect-domofon/animated-img/left-bottom.png'),
        src: 'left-bottom',
        left: '-15%',
        params: {
            bottom: '2%',
            left: '0',
            width: '12%',
            'max-width': '140px',
            height: 'auto',
        },
        tabletParams: {
            display: 'none',
        },
        mobileParams: {
            display: 'initial',
            width: '24%',
            bottom: 'auto',
            top: '26%',
            'max-width': '110px',
        },
    },
    {
        id: '4',
        image_webp: require('~/static/images/domofon/connect-domofon/animated-img/right-top.webp'),
        image: require('~/static/images/domofon/connect-domofon/animated-img/right-top.png'),
        src: 'right-top',
        right: '-15%',
        params: {
            top: '2%',
            right: '10%',
            width: '105px',
            height: '105px',
        },
        tabletParams: {
            right: '3%',
        },
        mobileParams: {
            display: 'none',
        },
    },
    {
        id: '5',
        image_webp: require('~/static/images/domofon/connect-domofon/animated-img/right-bottom.webp'),
        image: require('~/static/images/domofon/connect-domofon/animated-img/right-bottom.png'),
        src: 'right-bottom',
        right: '-15%',
        params: {
            bottom: '15%',
            right: '0',
            width: '11%',
            'max-width': '220px',
            height: 'auto',
        },
        tabletParams: {
            display: 'none',
        },
    },
];

export const imagesWithDomofon: IAnimatedImage[] = [
    {
        id: '1',
        image_webp: require('~/static/images/domofon/connect-domofon/animated-img/center.webp'),
        image: require('~/static/images/domofon/connect-domofon/animated-img/center.png'),
        src: 'center',
        params: {
            bottom: '15%',
            left: '50%',
        },
        laptopParams: {
            filter: 'blur(3px)',
            bottom: '10%',
        },
        mobileParams: {
            width: '90px',
            height: '90px',
            display: 'initial',
            bottom: '6%',
            left: '3%',
        },
    },
    {
        id: '2',
        image_webp: require('~/static/images/domofon/connect-domofon/animated-img/left-top.webp'),
        image: require('~/static/images/domofon/connect-domofon/animated-img/left-top.png'),
        src: 'left-top',
        left: '-15%',
        params: {
            top: '3%',
            left: '-10px',
            width: '110px',
            height: '110px',
        },
        desktopParams: {
            left: '-68px',
        },
        laptopParams: {
            display: 'none',
        },
        mobileParams: {
            width: '75px',
            height: '75px',
            left: '-25px',
        },
    },
    {
        id: '3',
        image_webp: require('~/static/images/domofon/connect-domofon/animated-img/left-bottom.webp'),
        image: require('~/static/images/domofon/connect-domofon/animated-img/left-bottom.png'),
        src: 'left-bottom',
        left: '-15%',
        params: {
            bottom: '2%',
            left: '0',
            width: '12%',
            'max-width': '140px',
            height: 'auto',
        },
        tabletParams: {
            display: 'none',
        },
    },
    {
        id: '4',
        image_webp: require('~/static/images/domofon/connect-domofon/animated-img/right-top.webp'),
        image: require('~/static/images/domofon/connect-domofon/animated-img/right-top.png'),
        src: 'right-top',
        right: '-15%',
        params: {
            top: '2%',
            right: '10%',
            width: '105px',
            height: '105px',
        },
        tabletParams: {
            right: '3%',
        },
        mobileParams: {
            display: 'none',
        },
    },
    {
        id: '5',
        image_webp: require('~/static/images/domofon/connect-domofon/animated-img/right-bottom.webp'),
        image: require('~/static/images/domofon/connect-domofon/animated-img/right-bottom.png'),
        src: 'right-bottom',
        right: '-15%',
        params: {
            bottom: '15%',
            right: '0',
            width: '11%',
            'max-width': '220px',
            height: 'auto',
        },
        tabletParams: {
            display: 'none',
        },
        mobileParams: {
            display: 'inherit',
            width: '70px',
            height: '80px',
            bottom: 'auto',
            right: '0',
            top: '60%',
        },
    },
];
